<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector
    ></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'push-template-list'"
      ></vdr-action-bar-items>
      <a
        class="btn btn-primary"
        *vdrIfPermissions="['CreatePushTemplate']"
        [routerLink]="['./', 'create']"
      >
        <clr-icon shape="plus"></clr-icon>
        {{ "push.create-template" | translate }}
      </a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2
  id="push-template-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="push-template-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-template="item">
      {{ template.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="created-at"
    [heading]="'common.created-at' | translate"
    [hiddenByDefault]="true"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-template="item">
      {{ template.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="updated-at"
    [heading]="'common.updated-at' | translate"
    [hiddenByDefault]="true"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-template="item">
      {{ template.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="push-type"
    [heading]="'push.type' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-template="item">
      <a class="button-ghost" [routerLink]="['./', template.id]">
        {{ template.type | formatCamelCase }}
        <clr-icon shape="arrow right" />
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="is-active"
    [heading]="'common.enabled' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-template="item">
      <vdr-chip
        style="cursor: pointer"
        *ngIf="template.isActive"
        colorType="success"
        (click)="onToggleActive(template, false)"
      >
        {{ "common.enabled" | translate }}
      </vdr-chip>
      <vdr-chip
        style="cursor: pointer"
        *ngIf="!template.isActive"
        colorType="warning"
        (click)="onToggleActive(template, true)"
      >
        {{ "common.disabled" | translate }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
